"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_ButtonCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_ButtonCard = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-shadow: var(--box-shadow-xs);\n    box-sizing: border-box;\n    width: 100%;\n    height: 45px;\n    border-radius: var(--border-radius-xs);\n    padding: 5px 20px 5px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.1s ease-in-out;\n    opacity: ", ";\n    color: ", ";\n    background: ", ";\n    pointer-events: ", ";\n"])), function (props) {
  return props.disabled && 'var(--opacity-25)';
}, function (props) {
  return props.disabled && 'var(--color-gray-500)';
}, function (props) {
  if (props.clicked) {
    return 'var(--color-primary)';
  } else {
    return 'transparent';
  }
}, function (props) {
  return props.disabled && 'none';
});
exports.Occ_ButtonCard = Occ_ButtonCard;